









import { Component, Prop, Vue } from 'vue-property-decorator';
import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card, CardSubmitEvent } from '@/shared/components/cardRenderer';
import { InstalledApp } from '@/features/apps/shared/models';
import {AppCard} from '@/features/apps/shared/models/appCard';

@Component({
	components: {
		CardRenderer
	}
})
export default class CapableAppSelection extends Vue {

	@Prop() public capableApps: InstalledApp[];

	public getCards(): Card[] {
		return [
			{
				id: 'homescreenAppSelection',
				content: this.createCardContent()
			}
		];
	}

	public cardSubmit(e: CardSubmitEvent) {
		const installedApp = this.capableApps.find(app => app.installedAppId === e.componentId);
		if (installedApp) {
			this.$emit('selected', installedApp);
		}
	}

	private createCardContent(): AppCard {
		const content: AppCard = {
			components: []
		};
		if (this.capableApps && this.capableApps.length) {
			const items = this.capableApps.map(app => this.createListItem(app.installedAppId, app.name, app.description || ''));
			content.components.push({
				type: 'list',
				disabled: false,
				items
			});
		} else {
			this.createError().map(x => content.components.push(x));
		}
		return content;
	}

	private createListItem(id: string, title: string, subtitle: string): CardListItem {
		return {
			type: 'item',
			id,
			title,
			subtitle: subtitle || 'Private app',
			action: {
				type: 'submit'
			}
		};
	}

	private createError() {
		return [
			{
				type: 'text',
				text: '# No relevant apps installed',
			},
			{
				type: 'spacer',
				size: 's'
			},
			{
				type: 'text',
				text: 'Visit the App Store to install existing apps, or create your own private app.'
			}
		];
	}
}

interface CardListItem {
	type: string;
	id: string;
	title: string;
	subtitle?: string;
	action?: {type: string};
}

